export enum Blames {
    Me = "Me",
    Carrier = "Carrier",
    Driver = "Driver",
    LogisticOperator = "LogisticOperator",
    Owner = "Owner"
}
